<template>
	<div>
		<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData" col="1"></compFormEdit>
		<vButtonGroup class="text-right margin-top-10">
			<vButton theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
			<vButton @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpTransaction, HttpSaveTransaction } from "@/service/billing";
// import { mapGetters } from "vuex";
import mixin from "./mixin";
export default {
	mixins: [mixin],
	props: ['params'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
	},
	data() {
		return {
			loading: false,
			formData: {}
		}
	},
	created(){
		this.getDetail();
	},
	computed: {
		getBase() {
			const isEdit = this.params.type === 'edit';
			return [
				{
					label: this.$t('fbb.accountmanage.thing_name', { defaultValue: "事务项名称" }),
					key: "transactionName",
				},
				{
					label: this.$t('fbb.accountmanage.thing_code', { defaultValue: "事务项Code" }),
					key: "transactionCode",
					query: isEdit,
				}, {
					label: this.$t('fbb.accountmanage.cost_source', { defaultValue: "计费值来源" }),
					key: "billingSourcesType",
					tag: "vSelect",
					options: this.getSourcesType,
					query: isEdit,
				}, {
					label: this.$t('fbb.accountmanage.description', { defaultValue: "描述" }),
					tag: "vTextarea",
					key: "remark",
					required: false,
				}
			];
		},
	},
	methods: {
		cancel() {
			this.$emit('on-close')
		},
		getDetail() {
			if (this.params.type === 'add') return;
			this.loading = true;
			HttpTransaction({ id: this.params.id }).then(res => {
				this.loading = false;
				this.formData = res.data;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message)
			})
		},
		async submit() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpSaveTransaction(this.formData).then(res => {
				this.cancel();
				this.$emit('on-update');
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message)
			})
		},
	},
}
</script>